import styled from 'styled-components';
import { themeGet, getMediaQuery } from '@magalu/stereo-ui-styles';
import { Box, Flex, Text } from '../../atoms';
export const Header = styled(Flex)`
  align-items: center;
  padding: 0 0 ${props => themeGet('space.2')(props)}px;

  ${getMediaQuery('large')} {
    padding: 0 0 ${props => themeGet('space.3')(props)}px;
  }
`;
export const ReviewWrapper = styled.span`
  width: 80px;
`;
export const ReviewerName = styled(Text).attrs(() => ({
  fontSize: 2
}))`
  color: ${props => themeGet('colors.darkSilver')(props)};
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  padding: ${props => themeGet('space.2')(props)}px;
  line-height: ${props => themeGet('lineHeights.plus')(props)}px;
`;
export const SubTitle = styled(Box).attrs(() => ({
  fontSize: 2
}))`
  color: #69727763;
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  line-height: ${props => themeGet('lineHeights.plus')(props)}px;
`;
export const Description = styled(Box).attrs(() => ({
  fontSize: 3
}))`
  color: ${props => themeGet('colors.darkSilver')(props)};
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  line-height: 24px;
  padding: ${props => themeGet('space.3')(props)}px 0
    ${props => themeGet('space.3')(props)}px;
  word-break: break-word;
`;
export const SeeMore = styled(Box).attrs(() => ({
  color: 'primary.base',
  fontSize: 1
}))`
  display: inline;
  text-decoration: underline;
  cursor: pointer;
`;
export const DateWrapper = styled(Box).attrs(() => ({
  fontSize: 2
}))`
  color: #69727763;
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  line-height: ${props => themeGet('lineHeights.tall')(props)}px;
`;